import React from 'react';

function LegalFooter() {
  return (
    <div className="bg-white rounded-lg shadow-sm p-3 sm:p-6">
      <div className="text-xs text-gray-600 leading-relaxed">
        <p className="font-medium mb-2">INFORMACIÓN SOBRE PROTECCIÓN DE DATOS:</p>
        <p>
          De conformidad con lo previsto en el artículo 5 de la Ley Orgánica 15/1999 de 13 de Diciembre,
          se informa que los datos recabados en el siguiente formulario serán incorporados en un fichero 
          titularidad del cliente cuya finalidad es la gestión del suministro de uniformes de empleados. 
          El titular de los datos consiente expresamente que sus datos sean trasladados para la finalidad 
          entradicha, pudiendo ejercitar los derechos de acceso, rectificación, cancelación y oposición 
          en los términos previstos en la Ley Orgánica 15/1999, dirigido escrito a [insertar denominación 
          dpto. y dirección]. Los datos señalados con asteríscos son de carácter voluntario.
        </p>
      </div>
    </div>
  );
}

export default LegalFooter;